import React, { Component } from 'react';

const Changes = props => {
  let content = '';
  let itemContent = '';
  let itemsName = '';
  if (props.dataItem.length > 0) {
    content = props.dataItem.map((item, i) => {
      return <li key={i + 1}>{item.name}</li>;
    });
  }

  if (props.itemsToEdit.length > 0) {
    itemContent = props.itemsToEdit.map((item, i) => {
      return <li key={i + 1}>{item.name}</li>;
    });
  }

  if (props.itemsName.length > 0) {
    itemsName = props.itemsName.map((item, i) => {
      return <li key={i + 1}>{item}</li>;
    });
  }
  return (
    <div className="item-changes">
      <div>
        {props.dataItem.length > 0 ? <span>{props.language.card.item.new_items}</span> : ''}
        <ul>{content}</ul>
      </div>
      <div>
        {props.itemsToEdit.length > 0 ? <span>{props.language.card.item.edited_items}</span> : ''}
        <ul>{itemContent}</ul>
      </div>
      <div>
        {props.itemsName.length > 0 ? <span>{props.language.card.item.delete_items}</span> : ''}
        <ul>{itemsName}</ul>
      </div>
    </div>
  );
};

export default Changes;



// WEBPACK FOOTER //
// ./source/client/components/dynamic_list/changes.jsx